import { observable } from "@legendapp/state"
import { use$ } from "@legendapp/state/react"
import type { TContactsFilter } from "@/schemas/api/dynamo/dynamo.schema"

interface MessengerData {
  selectedContactID?: string
  filter?: TContactsFilter
  isOpenedDesktopSelector?: boolean
}

const initialState: MessengerData = {
  selectedContactID: undefined,
  filter: undefined,
  isOpenedDesktopSelector: false,
}

export const messengerStore$ = observable<MessengerData>(initialState)

export function useSelectedContactID() {
  const selectedContactID = use$(() => messengerStore$.selectedContactID.get())

  return selectedContactID
}
